const eventSocialMedia = (params) => {
  (window as any)?.dataLayer?.push({
    event: `generalEvent`,
    eventName: `footer_${params.toLowerCase()}_button`,
    eventCategory: `header & footer navigation`,
    eventAction: `click on ${params.toLowerCase()}`,
    eventLabel: `ikuti kami`,
  });
};
export default eventSocialMedia;
